/**
 * 모바일 뒤로 가기(specs/092 R-9) — 상단바와 화면(없는 사업 안내 후 복귀 등)이 같은 규칙을 쓴다.
 * 앱 안의 이전 기록이 있을 때만 뒤로 가고, 아니면(주소로 바로 연 경우) 허용된 첫 탭으로 간다.
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { ROUTES } from '@/config/routes';

import { useMobileTabs } from '../config/mobileTabs';

export function useMobileBack() {
  const navigate = useNavigate();
  const firstTab = useMobileTabs()[0]?.to ?? ROUTES.workspace.mobile.root;
  return useCallback(() => {
    // react-router 는 기록마다 순번(idx)을 남기며 새 화면 이동은 +1, 기록 교체(replace — 연도 동기화·검색어 반영 등)는 그대로다.
    // location.key 는 replace 에도 바뀌어 "첫 진입"을 판별할 수 없다(PR #173 리뷰).
    const index = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (index > 0) navigate(-1);
    else navigate(firstTab);
  }, [firstTab, navigate]);
}
